<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'ProductionView',
  mounted() {
    this.$store.state.tabs = [
      {
        text: this.$t('shipments'),
        to: '/orders/shipments',
      },
      {
        text: this.$t('sales_orders'),
        to: '/orders/sales-orders',
      },
      {
        text: this.$t('generated_lots'),
        to: '/orders/lots',
      },
    ]
  },
}
</script>
